import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TwoFactorError, TwoFactorSelect } from '@ibk/shared-auth';
import { TranslationProvider } from '@ibk/shared-translation';
import { Card, Icon, Loading } from '@ibk/shared-ui';
import { dominioEscritorioTranslations } from '../../translations';
import styles from './TwoFactorSelect.module.css';
import { useTwoFactorSelect } from './useTwoFactorSelect';
function TwoFactorSelectContent() {
    const { options, setSelected, loading, error, setError, hasAccessLoading, handleContinue, handleBack } = useTwoFactorSelect();
    const renderContent = () => {
        if (hasAccessLoading) {
            return (_jsx("div", { className: styles.loadingContainer, children: _jsx(Loading, { size: 'medium' }) }));
        }
        if (options.length === 0) {
            return _jsx(TwoFactorError, { onButtonClick: handleBack });
        }
        return (_jsx(TwoFactorSelect, { options: options.map(opt => ({ ...opt, icon: _jsx(Icon, { name: opt.icon }) })), onSelect: setSelected, onContinue: handleContinue, onBack: handleBack, loading: loading, error: error, onErrorClose: () => setError(null), theme: {
                primaryColor: '#d64000',
            } }));
    };
    return (_jsx("main", { className: styles.container, children: _jsx(Card, { style: { padding: 36, maxWidth: 340, width: '100%' }, className: styles.card, children: renderContent() }) }));
}
export default function TwoFactorSelectPage() {
    return (_jsx(TranslationProvider, { translations: dominioEscritorioTranslations, defaultLanguage: 'pt-BR', children: _jsx(TwoFactorSelectContent, {}) }));
}
